/**
 * QL-281 — Add / edit goal modal shell for the Goal List.
 *
 * Remounts the form per goal (and per open) so it always starts from that
 * goal's stored values and never carries a half-typed edit into the next one.
 * The form itself lives in `goal-list-form.tsx`.
 */

import { GoalListForm, type GoalListFormProps } from "./goal-list-form";

type GoalListFormDialogProps = GoalListFormProps & { open: boolean };

export function GoalListFormDialog({ open, ...props }: GoalListFormDialogProps) {
  return open ? <GoalListForm key={props.goal?.id ?? "new"} {...props} /> : null;
}
